import PropTypes from 'prop-types';
import { useSessionStorage } from 'usehooks-ts';
import { nanoid } from 'nanoid';
import { useState } from 'react';

import { CONNECTION_STATUS } from 'common/constants';
import { Button, ConnectionStatusLabel } from 'ui';

import IntegrationCard from './IntegrationCard';
import appSettings from '../../app-settings';

const LinkedInCard = ({ onDisconnect, integrations }) => {
  const [, setAuthState] = useSessionStorage('auth-state');
  const [loading, setLoading] = useState(false);

  const getConnectionStatus = () => {
    if (integrations.length) {
      return CONNECTION_STATUS.connected;
    }
    return CONNECTION_STATUS.notConnected;
  };

  const pages = getConnectionStatus() !== CONNECTION_STATUS.notConnected ? integrations[0].pages : [];

  const handleConnectLinkedIn = () => {
    const state = nanoid();
    setAuthState(state);

    window.location.href = `https://www.linkedin.com/oauth/v2/authorization?${new URLSearchParams({
      client_id: appSettings.linkedInAppClientId,
      redirect_uri: `${appSettings.redirectUri}integrations?type=linkedIn`,
      state,
      response_type: 'code',
      scope: 'w_organization_social r_organization_social rw_organization_admin r_organization_social_feed',
    })}`.replaceAll(/\+/g, '%20'); // URLSearchParams encodes spaces as '+', which is not valid for LinkedIn
  };

  const handleDisconnect = async () => {
    setLoading(true);
    try {
      await onDisconnect(integrations[0].integrationId);
    } finally {
      setLoading(false);
    }
  };

  return (
    <IntegrationCard>
      <div className="flex items-center justify-between space-x-6">
        <div className="flex items-center space-x-6">
          <div className="w-[140px]">
            <img src="/integrations/linkedIn-logo.png" className="m-auto h-auto w-[140px]" alt="LinkedIn Logo" />
          </div>

          <div className="space-y-2">
            <div className="flex items-center space-x-2">
              <h3 className="text-h5 font-semibold">LinkedIn</h3>

              <ConnectionStatusLabel status={getConnectionStatus()} />
            </div>

            {getConnectionStatus() !== CONNECTION_STATUS.notConnected ? (
              <div>
                <h4 className="text-base font-semibold">Connected pages:</h4>
                <ul className="list-inside list-disc text-base">
                  {pages.map((page) => {
                    return (
                      <li key={page.id}>
                        <span className="mr-2">{page.name}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : (
              <p className="text-base">
                Connect your LinkedIn account to post to your organization&apos;s LinkedIn pages.
              </p>
            )}
          </div>
        </div>

        {getConnectionStatus() !== CONNECTION_STATUS.notConnected ? (
          <Button title="Disconnect LinkedIn Account" color="primary" onClick={handleDisconnect} loading={loading} />
        ) : (
          <Button title="Connect LinkedIn Account" color="primary" onClick={handleConnectLinkedIn} />
        )}
      </div>
    </IntegrationCard>
  );
};

LinkedInCard.defaultProps = {
  integrations: [],
};

LinkedInCard.propTypes = {
  onDisconnect: PropTypes.func.isRequired,
  integrations: PropTypes.arrayOf(PropTypes.object),
};

export default LinkedInCard;
